import axios from "axios";
import { LOGRADOUROS_LIST } from "./Events";
import { notifyApiError } from "./utils";


export function get(id, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLogradouro/Get/${id}`);

    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}


export function list(filter) {
  return function (dispatch) {
    const request = axios.post(`/PublicLogradouro/List`, filter);

    request
      .then(response => {
        dispatch({ type: LOGRADOUROS_LIST, payload: response.data });
      })
      .catch((error) => {
        notifyApiError(error, 'Não foi possível buscar os logradouros');
      });
  };
}

export function identifyOnExtent(geographicExtent, successCallback) {
  return function (dispatch) {
    const request = axios.post(`/PublicLogradouro/IdentifyOnExtent`, geographicExtent);

    request
      .then(response => {
        
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {

      });
  };
}

export function clearResults() {
  return function (dispatch) {
    dispatch({ type: LOGRADOUROS_LIST, payload: null });
  };
}